import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

import { ApiService } from '../api.service';
import { Contact } from '@models';

@Injectable()
export class ContactService extends ApiService<Contact> {

    protected apiGroup: string = 'crm';
	protected apiName: string = 'contact';

	constructor(
		public http: HttpClient,
		public translate: TranslateService,
		public confirmationService: ConfirmationService,
		public messageService: MessageService
	) {
		super(http, translate, confirmationService, messageService);
	}

	/**
	 * getSingle(id)
	 * Retrieve single object
	 */
	/*getLoginAsLink(id: number): Observable<getLoginAsLinkResponse<Contact>> {
		return this.http.get<getLoginAsLinkResponse<Contact>>(
			this.getBaseUrl('get_login_as_link', id.toString())
		).retry(this.retries);
    }*/
    
    getLoginAsUrl(id: number): string {
        return this.getBaseUrl('get_login_as_link', id.toString());
    }
}


export interface getLoginAsLinkResponse<T> {
    success: boolean;
    error: string;
    url: string; 
}


// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/services/crm/contact.service.ts